export const stepsStyleValidation = (
  stepNumber,
  lowerSteps,
  upperSteps,
  allStepsForUpper,
  allStepsForLower,
  startTogether,
  passiveAligners,
  upperOverCorrectionStepsNumber,
  lowerOverCorrectionStepsNumber,
  isUpper
) => {
  let styleArray = [];
  if(startTogether) {
    if (isUpper) {
      if(stepNumber < allStepsForUpper - upperOverCorrectionStepsNumber) {
        styleArray.push('bounty_step');
      } else {
       
        upperOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
      }
     } else {
      if(stepNumber < allStepsForLower - lowerOverCorrectionStepsNumber) {
        styleArray.push('bounty_step');
      } else {
        lowerOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
      }
     }
  } else {
    if (isUpper) {
      if (allStepsForUpper === 1) {passiveAligners? styleArray.push('bounty_passiveAligners') : styleArray.push('bounty_emptyStep')}
      if (allStepsForUpper === allStepsForLower) {
        if(stepNumber < allStepsForUpper - upperOverCorrectionStepsNumber) {
          styleArray.push('bounty_step');
        } else {
          upperOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
        }
      }
      if (allStepsForUpper < allStepsForLower) {
        if (stepNumber <= allStepsForLower- allStepsForUpper) {
          styleArray.push('bounty_step');
        }
        else if (stepNumber >= allStepsForLower- allStepsForUpper && stepNumber < allStepsForLower - upperOverCorrectionStepsNumber ) {
          styleArray.push('bounty_step');
        } else {
          upperOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
        }
      } else {
        if (stepNumber <= allStepsForUpper- allStepsForLower) {
          styleArray.push('bounty_step');
        }
        else if (stepNumber >= allStepsForUpper- allStepsForLower && stepNumber < allStepsForUpper - upperOverCorrectionStepsNumber) {
          styleArray.push('bounty_step');
        } else {
          upperOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
        }
      }
    } else {
      if (allStepsForLower === 1) {passiveAligners? styleArray.push('bounty_passiveAligners') : styleArray.push('bounty_emptyStep')}
      if (allStepsForLower === allStepsForUpper) {
        if(stepNumber < allStepsForLower - lowerOverCorrectionStepsNumber) {
          styleArray.push('bounty_step');
        } else {
          lowerOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
        }
      }
      if (allStepsForUpper < allStepsForLower) {
        if (stepNumber <= allStepsForLower- allStepsForUpper) {
          styleArray.push('bounty_step');
        }
        else if (stepNumber >= allStepsForLower- allStepsForUpper && stepNumber < allStepsForLower - lowerOverCorrectionStepsNumber) {
          styleArray.push('bounty_step');
        } else {
          lowerOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
        }
      } else {
        if (stepNumber <= allStepsForUpper- allStepsForLower) {
          styleArray.push('bounty_step');
        }
        else if (stepNumber >= allStepsForUpper- allStepsForLower && stepNumber < allStepsForUpper - lowerOverCorrectionStepsNumber) {
          styleArray.push('bounty_step');
        } else {
          lowerOverCorrectionStepsNumber === 0 ? styleArray.push('bounty_step') : styleArray.push('bounty_overCorrectionStepsNumber')
        }
      }
    }
  }
  return styleArray.join(" ");
};